import React, { useContext } from "react";
import { Row, Col } from "react-bootstrap";
import Select from "react-select";
import { UserContext } from "../reuseableComponents/auth/UserContext";

const style = {
  control: (base) => ({
    ...base,
    border: "1px solid grey",
    // This line disable the blue border
    boxShadow: "none"
  })
};

const ReportsMenu = ({ handleMenuChange, loading, reportItems, systemId, defaultValue }) => {
  const { user } = useContext(UserContext);
  let publicMenu = reportItems.filter((menu) => menu.access === "Public");

  //Portal Users need access to systems they are connected to but should have
  //a public view for systems they are not connected to
  let hasAccess = user.isPortalUser ? user.systems.some((system) => system.systemId === parseInt(systemId)) : false;

  return (
    <>
      <Row>
        <Col>
          <Select
            options={user.isStaff || user.isSysAdmin || hasAccess ? reportItems : publicMenu}
            isSearchable
            isLoading={loading}
            className='mb-4'
            placeholder='Water System Reports'
            onChange={handleMenuChange}
            value={defaultValue}
            id='reports-menu'
            styles={style}
          />
        </Col>
      </Row>
    </>
  );
};

export default ReportsMenu;
